import wixData from 'wix-data';
import wixLocation from 'wix-location';
import { getCalculatedRelatedItems } from 'backend/store.jsw';
let product;

$w.onReady(async function () {

	$w('#rpRep').onItemReady(($item, data) => {
		if (data.mainMedia) {
			$item('#productImage').src = data.mainMedia;
			$item('#productImage').link = data.productPageUrl;
			$item('#productImage').tooltip = data.name;
		}

		if (data.name.length > 20) {
			$item('#productName').text = `${data.name.substr(0, 20)}..`;
		} else {
			$item('#productName').text = data.name;
		}

		$item('#productPrice').text = data.formattedDiscountedPrice

	})

	wixLocation.onChange(() => {
		initializeRelatedProducts();
	})

	initializeRelatedProducts();
});

async function initializeRelatedProducts() {
	$w('#rpRep').data = [];
	let relatedProducts = [];
	product = await $w('#productPage').getProduct();

	// Get the related products:
	relatedProducts = await wixData.query('RelatedProducts').eq('product', product._id).include('relatedProducts').find().then((result) => {
		if (result.length > 0) {
			if (result.items[0].relatedProducts) {
				return result.items[0].relatedProducts; // Array
			} else {
				return [];
			}
		} else {
			return [];
		}
	})

	if (relatedProducts.length === 4) {
		$w('#rpRep').data = relatedProducts;
	} else if (relatedProducts.length > 4) {
		$w('#rpRep').data = relatedProducts.slice(0, 4);
	} else {
		let tempItems = [];
		let calculatedItems = []
		if (relatedProducts.length > 0) { tempItems = tempItems.concat(relatedProducts) }
		
		calculatedItems = await getCalculatedRelatedItems(product.discountedPrice, product.name, (4 - relatedProducts.length));

		if (calculatedItems.length > 0) {
			tempItems = tempItems.concat(calculatedItems);
		}

		if (tempItems.length > 0) {
			$w('#rpRep').data = tempItems;
		}
	}

	if ($w('#rpRep').data.length > 0) {
		if ($w('#relatedProductsStrip').collapsed) { $w('#relatedProductsStrip').expand() }
	} else {
		if (!$w('#relatedProductsStrip').collapsed) { $w('#relatedProductsStrip').collapse() }
	}
}